<template>
  <QLayout
    class="layout"
    view="lHh lpr lFf"
    :style="{ 'background-image': `url(${backgroundImage})` }"
  >
    <QPageContainer>
      <QPage class="items-center justify-around page scroll">
        <div :class="['row justify-around', { 'col-grow': $q.screen.lt.sm }]">
          <div
            style="margin: 66px 0 35px"
            :class="[
              'col-12 flex justify-center q-mt-lg q-mb-md',
              { 'q-my-lg': $q.screen.lt.md }
            ]"
          >
            <QImg
              :src="theme().novatedBrand?.logo?.white"
              basic
              contain
              width="350px"
            />
          </div>
          <router-view />
        </div>
      </QPage>
    </QPageContainer>
    <QFooter class="bg-transparent">
      <SAIFooter
        :dense="$q.screen.lt.sm"
        :rightsReservedLong="theme().defaultBrand?.legal?.rightsReservedLong"
      />
    </QFooter>
  </QLayout>
</template>

<script>
import { QLayout, QFooter, QPageContainer, QPage, QImg } from 'quasar';
import { SAIFooter, getAsset } from 'ecx.saigon.ui.common';
import { mapGetters } from 'vuex';

export default {
  name: 'SignUpLayout',
  data() {
    return {
      backgroundImage: undefined,
      logo: undefined
    };
  },
  computed: {
    ...mapGetters('user', ['theme'])
  },
  async mounted() {
    this.backgroundImage = await getAsset(
      this.$Constants.SIGNING_BACKGROUND_PATH
    );
  },
  components: {
    QPageContainer,
    QPage,
    QLayout,
    QFooter,
    SAIFooter,
    QImg
  }
};
</script>

<style lang="sass" scoped>
.page
  height: 0

  @media screen and (min-width: 1024px)
    display: flex

.layout
  background-position: center
  background-repeat: no-repeat
  background-size: cover
</style>
